/** Fenêtre glissante alignée sur les métriques d'apprentissage. */
export const GRADUATION_LOOKBACK_DAYS = 90;
